import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Route değiştiğinde sayfayı en üste kaydırır
 */
const ScrollToTop: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
